export const transformExponent = (exponent: string): string => {
  const exponentTrimmed = exponent?.trim();

  if (!exponent || !exponentTrimmed) {
    return '';
  }

  if (exponentTrimmed === '00') {
    return '';
  }

  let firstLetterDifferentFromZero = false;

  let newExponent = exponentTrimmed;

  for (const letter of exponentTrimmed) {
    if (letter !== '0') {
      firstLetterDifferentFromZero = true;
    }

    if (!firstLetterDifferentFromZero) {
      newExponent = newExponent.replace('0', '');
    }
  }

  return newExponent ? `/${newExponent}` : '';
};
